<ng-container *ngIf="(applicationStateService.isApplicationLoaded() | async) else loading">

  <div class="visualize flex-grow-1 d-flex flex-column">
    <div #canvasContainer class="visualize-image-container flex-grow-1 d-flex flex-column">
    </div>

    <div class="visualize-in-progress" *ngIf="isLoading$ | async">
      <div class="spinner-border text-primary" style="width: 60px; height: 60px" role="status">
      </div>
    </div>

  </div>
</ng-container>

<!-- loading indicator -->
<ng-template #loading>
  <div #canvasPlaceholder class="visualize-image-container loading-animation flex-grow-1 d-flex flex-column">
    <div class="loading-image"></div>
  </div>
</ng-template>
